<template>
  <div class="flex-col org-main">
    <div class="div-top">
      <i class="iconfont iconcapital-outline"
        style="font-size: 0.875rem; color: #d04a02"></i>
      <div class="org-name">{{ $t("investdCompany") }}</div>
      <div id="invested-list-filter"
        class="filter"
        v-if="showFilter"
        @click="showSearch">
        <span>{{ $t("common.filter") }} </span>
        <i class="iconfont iconfilter-outline"></i>
      </div>
      <van-popup v-model="showSearchPanel"
        position="right"
        :style="{ height: '100%', width: '80%' }">
        <search-panel :type="searchPanelType"
          @search="searchByPanel"
          ref="orgSelect"></search-panel>
      </van-popup>
    </div>
    <div class="cont-list">
      <van-list v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <invested-item v-for="item in list"
          v-bind:key="item.id"
          :data="item"
          :show-chk="isEdit"
          @cancel="cancelMark"
          :disable-swipe="disableSwipe"></invested-item>
      </van-list>
    </div>
  </div>

</template>

<script>
import InvestedItem from "./InvestedItem";
import SearchPanel from "@components/common/SearchPanel";
import common from "@common/common";
import webService from "@network/webService";
export default {
  name: "",
  data () {
    return {
      disableSwipe: true,
      list: [],
      loading: false,
      finished: false,
      currentPage: 0,
      showSearchPanel: false,
      searchPanelType: common.searchTypeEnum.invested,
      oldSearchModel: {
        Search: "",
        SearchType: common.relationshipSearchTypeEnum.PEContact,
      },
      showFilter: false,
      isHistory: false,
    };
  },
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InvestedItem,
    SearchPanel,
  },
  mounted () {
    this.showFilter =
      this.pageType != common.searchTypeEnum.investedHistory;
    this.disableSwipe =
      this.pageType != common.searchTypeEnum.investedCollect;
  },
  methods: {
    changeSearchValue (value) {
      this.oldSearchModel.Search = value;
    },
    reset () {
      console.log("reset");
      this.list = [];
      this.loading = false;
      this.finished = false;
    },
    onLoad () {
      if (this.currentPage == 0) {
        this.list = [];
      }
      this.requestPageData();
    },
    showSearch () {
      this.showSearchPanel = true;
      this.$nextTick(function () {
        if (this.isHistory) {
          this.$refs.orgSelect.resetPanel();
        }
        this.$refs.orgSelect.initSelectItem();
      });
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        document.getElementById('invested-list-filter').classList.add('has-filter');
      } else {
        document.getElementById('invested-list-filter').classList.remove('has-filter');
      }
      this.currentPage = 0;
      this.list = [];
      if (this.searchPanelType == common.searchTypeEnum.invested) {
        this.oldSearchModel.SearchType =
          common.relationshipSearchTypeEnum.Invested;
        // this.oldSearchModel.   = searchParams.CountryIds;
        this.oldSearchModel.IndustryNames = searchParams.IndustryNames;
        this.oldSearchModel.InvestmentRoundIds =
          searchParams.InvestmentRoundIds;
        this.oldSearchModel.InvestmentDate =
          searchParams.InvestmentDate;
      }
      this.showSearchPanel = false;
      console.log(searchParams);
      this.requestPageData();
    },
    getData (searchModel) {
      if (searchModel.isHistory) {
        this.isHistory = true;
      }
      if (searchModel.hasFilter) {
        document.getElementById('invested-list-filter').classList.add('has-filter');
      } else {
        document.getElementById('invested-list-filter').classList.remove('has-filter');
      }
      this.currentPage = 0;
      this.loading = true;
      this.list = [];
      if (!searchModel) {
        searchModel = {
          PageSize: 20,
          Page: 0,
          SearchType: common.relationshipSearchTypeEnum.Invested,
        };
      } else if (this.searchPanelType == common.searchTypeEnum.invested) {
        this.oldSearchModel = searchModel;
      }
      //web 数据请求
      this.requestPageData(true);
    },
    requestPageData (isFirst) {
      let searchModel = {
        PageSize: 20,
        Page: this.currentPage,
        SearchType: this.oldSearchModel.SearchType,
        Search: this.oldSearchModel.Search,
        // CountryIds: this.oldSearchModel.CountryIds,
        IndustryNames: this.oldSearchModel.IndustryNames,
        InvestmentRoundIds: this.oldSearchModel.InvestmentRoundIds,
        InvestmentDate: this.oldSearchModel.InvestmentDate,
      };
      if (this.pageType == common.searchTypeEnum.investedCollect) {
        webService.getCompanyListFavorite(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData_collect(this, res.data);
        });
      } else if (this.pageType == common.searchTypeEnum.investedHistory) {
        webService.getCompanyListHistory(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData(this, res.data);
        });
      } else {
        webService.getCompanyList(searchModel).then((res) => {
          console.log(res.data);
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData(this, res.data);
        });
      }
    },
    selectAll () {
      this.list.forEach((element) => {
        element.checked = true;
      });
    },
    cancelSelected () {
      this.list.forEach((element) => {
        element.checked = false;
      });
    },
    deleteItem () {
      common.batchDeleteMarked(this);
    },
    cancelMark (id) {
      common.cancelMark(this, id);
    },
  },
};
</script>

<style lang='less' scoped>
.org-main {
  height: 99%;
  border-top: 1px solid #dedede;
}
.div-top {
  display: flex;
  padding: 0.375rem 0.625rem;
  align-items: center;
  height: 2.875rem;
  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
    margin-left: 0.375rem;
  }
  .filter {
    text-align: right;
    flex: 1;
    span {
      font-size: 0.875rem;
    }
    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}
.cont-list {
  overflow: auto;
  flex: 1;
  height: 100%;
}
/deep/ .van-list {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/InvestedList.vue